<script setup lang="ts">
  import type { HTMLAttributes } from 'vue'
  import { cn } from '@/lib/utils'

  const props = defineProps<{
    class?: HTMLAttributes['class'],
  }>()
</script>

<template>
  <div
    data-slot="card-content"
    :class="cn('px-5 py-2.5', props.class)">
    <slot></slot>
  </div>
</template>
